import $ from 'jquery';

const navbarToggle = (opening) => {
  $('.navbar-toggler').each(function() {
    $(this).toggleClass( 'collapsed' )
  });

  if(opening) {
    window.saveScrollPosition();
    window.disable_scroll();
  } else {
    window.enable_scroll();
  }

  $('.collapse').slideToggle();
}

$(window).on('load', function () {
  $(document).on( 'click', '.navbar-toggler', function() {
    navbarToggle($(this).hasClass('collapsed'));
  });
});
